export default {
  REACT_APP_API_ENDPOINT: 'https://intense-stream-48886.herokuapp.com/api',
  REACT_APP_TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY
};
